import { defineNuxtPlugin } from '#app'
import { useHead } from '#imports'

export default defineNuxtPlugin(async (nuxtApp) => {
    const siteStore = useSiteStore()

    const gaId = siteStore.siteConfig.elements?.googleAnalytics

    if (!gaId?.value) return

    useHead({
        script: [
            {
                src: `https://www.googletagmanager.com/gtag/js?id=${gaId.value}`,
                async: true
            },
            {
                innerHTML: `
                window.dataLayer = window.dataLayer || [];
                function gtag(){dataLayer.push(arguments);}
                gtag('js', new Date());
                gtag('config', '${gaId.value}');
                `
            }
        ]
    })
})
